import { HttpStatusCodes } from 'Utilities/ClientResponseUtility';
import { useUserData } from 'Foundation/User/UserContext';

function AccessDeniedMessage(props: { status: HttpStatusCodes; activityDataType: string; responseMessage: string }) {
  const { userData } = useUserData();

  const getLdapGroup = (): string => {
    let BLBilling = 'lram_portal_billing';
    let BLClaims = 'lram_portal_claims';
    let BLQuotePolicy = 'lram_portal_iq';
    let ldapGroup: string = '';
    switch (props.activityDataType) {
      case 'billing': {
        ldapGroup = BLBilling;
        break;
      }
      case 'claims': {
        ldapGroup = BLClaims;
        break;
      }
      case 'policy': {
        ldapGroup = BLQuotePolicy;
        break;
      }
    }
    return ldapGroup;
  };
  return !userData ? (
    <div>
      <p>Access Denied - {props.activityDataType}.</p>
    </div>
  ) : userData.isAgent() || userData.isMockingAgent ? (
    <div>
      <p>
        Access Denied - {props.activityDataType}. You will need to be added to the {props.activityDataType} security
        group.
      </p>
    </div>
  ) : !userData.isAgent() ? (
    <div>
      <p>
        Access Denied - {props.activityDataType}. Use{' '}
        <a href="https://requestit.lmig.com/web/viewForm.do?form=3013">RIT 3013</a> to be added to the LDAP group '
        {getLdapGroup()}'. Select 'internal' and 'production'
      </p>
    </div>
  ) : (
    <div>
      <p>Access Denied - {props.activityDataType}.</p>
    </div>
  );
}

export default AccessDeniedMessage;
